import { ApiErrorResponse } from '../classes/ApiErrorResponse';
import { ApiErrorCodes, ErrorCodes } from '../enums/ErrorCodes';

export function createApiError(errorCode: ErrorCodes | ApiErrorCodes): ApiErrorResponse {
  return {
    error: {
      message: errorCode
    }
  } as unknown as ApiErrorResponse;
}

export function throwApiError(errorCode: ErrorCodes | ApiErrorCodes): never {
  throw createApiError(errorCode);
}
